import { LoaderProgressBarComponent } from '@shared/components/loader/progress-bar/progress-bar.component';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoaderService } from '@shared/components/loader/loader.service';
import { LOADER_TYPE } from '@shared/components/loader/loader.model';
import { InfiniteLoaderComponent } from '@shared/components/loader/infinite-loader/infinite-loader.component';

@Component({
    selector: 'loader',
    imports: [CommonModule, InfiniteLoaderComponent, LoaderProgressBarComponent],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {
  LOADER_TYPE = LOADER_TYPE;
  loader$ = this.loaderService.getLoader();

  constructor(private loaderService: LoaderService) {}
}
